export const TypeRequestUpdateEnum = Object.freeze({
    poi: 'poi',
    building: 'building',
    street:'street',
    boundary:'boundary'
})